/**
 * ConnectionDot — shows the real-time channel state. Status = icon + text + colour (§6).
 * "polling" is a graceful degradation, not an error — phrased neutrally.
 */
import type { ConnectionState } from "@/hooks/useFeedChannel";
import { Badge } from "@/components/ui/Badge";
import type { BadgeTone } from "@/components/ui/Badge";
import { CircleIcon, WifiOffIcon, ClockIcon } from "@/components/ui/icons";

const map: Record<
  ConnectionState,
  { tone: BadgeTone; label: string; Icon: typeof CircleIcon }
> = {
  connecting: { tone: "neutral", label: "Подключение…", Icon: ClockIcon },
  live: { tone: "accent", label: "Онлайн", Icon: CircleIcon },
  polling: { tone: "warning", label: "Обновление по таймеру", Icon: ClockIcon },
  offline: { tone: "danger", label: "Нет связи", Icon: WifiOffIcon },
};

export function ConnectionDot({ state }: { state: ConnectionState }) {
  const { tone, label, Icon } = map[state];
  return (
    <Badge tone={tone}>
      <Icon size={11} />
      {label}
    </Badge>
  );
}
